/*
 * @Description: 
 * @Date: 2020-09-28 13:30:17
 */
import Vue from 'vue'
import SvgIcon from '@/components/svgIcon'// svg组件

Vue.component('svg-icon', SvgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /\.svg$/)
requireAll(req)